export const getCitiesSuccess = (listCities = []) => {
    return {
      type : 'GET_CITIES_SUCCESS',
      payload: listCities 
    }
  };
  